import { Box, Grid } from '@mui/material';
import { memo } from 'react';
import SurveyListRadioGroup from './SurveyListRadioGroup';

function Stepper2(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Box sx={{ px: '1.625rem' }}>
        <Grid
          container
          spacing={2}
          sx={{
            mt: '1.5rem',
            width: '100%',
            display: 'flex',
            justifyContent: { xs: 'flex-start', lg: 'center' },
          }}
        >
          <Grid item xs={5}>
            <SurveyListRadioGroup />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

export default memo(Stepper2);
